/**
 * The customers page's "Covered by" choice, remembered for the tab.
 *
 * So the sidebar on a customer's page lists the same customers the page it
 * was opened from did. Per browser tab (sessionStorage), and a convenience
 * only: the value is a `?user=` the server intersects with the caller's
 * own scope, exactly as it does for the customers page, so nothing stored
 * here can widen what anybody sees.
 */

const KEY = "sage.customers.cover";

export interface CoverFilter {
  /** A user's uuid, or "none" for customers nobody covers. */
  user: string;
  /** What to call it, since the sidebar does not load the user list. */
  label: string;
}

export function readCover(): CoverFilter | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CoverFilter) : null;
  } catch {
    return null;
  }
}

export function writeCover(value: CoverFilter | null): void {
  try {
    if (value) sessionStorage.setItem(KEY, JSON.stringify(value));
    else sessionStorage.removeItem(KEY);
  } catch {
    // Storage refused (private mode, blocked site data): the sidebar just
    // lists everything in scope.
  }
}
